export const GET_ALL_PROVIDERS_REQUESTED = 'GET_ALL_PROVIDERS_REQUESTED';
export const GET_ALL_PROVIDERS_SUCCEEDED = 'GET_ALL_PROVIDERS_SUCCEEDED';
